import { render, staticRenderFns } from "./CheckboxView.vue?vue&type=template&id=b38c0dbe&"
import script from "./CheckboxView.vue?vue&type=script&lang=ts&"
export * from "./CheckboxView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports